export const markupErrorMessageSearch = () =>
  `
    <p class="catalog-message">
        <span>OOPS...</span>
        <span>We are very sorry!</span>
        <span>We don’t have any results matching your search.</span>
    </p >
    `;
